import { render, staticRenderFns } from "./instructions.vue?vue&type=template&id=890f6adc&scoped=true&"
import script from "./instructions.vue?vue&type=script&lang=js&"
export * from "./instructions.vue?vue&type=script&lang=js&"
import style0 from "./instructions.vue?vue&type=style&index=0&lang=css&"
import style1 from "./instructions.vue?vue&type=style&index=1&id=890f6adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890f6adc",
  null
  
)

export default component.exports